'use client';

import dynamic from 'next/dynamic';

import { EventListSkeleton } from '../skeleton';

const EventList = dynamic(() => import('./event-list'), {
  ssr: true,
  loading: () => <EventListSkeleton />,
});

export { EventList as LazyEventList };
